<template>
  <div class="product-details-content-setup-step-02">
    <div class="mb-9">
      <step-title
        title="Personalização"
        description="Defina como será a cara do seu produto para seus alunos."
        icon="fa-solid fa-pen-ruler"
      />
    </div>

    <b-tabs justified>
      <b-tab :title="tab1Title" active class="pt-6">
        <tab-color :form="form" :errors="errors" />
      </b-tab>
      <b-tab :title="tab2Title" class="pt-6">
        <tab-login-image :form="form" :errors="errors" />
      </b-tab>
      <b-tab title="Capa" class="pt-6">
        <tab-cover :form="form" :errors="errors" />
        <div class="mt-9 fs-14">
          Capa versão quadrada
        </div>
        <div class="row pt-5 pb-2 mb-5">
          <div class="col-lg-10 py-3">
            <cover-option :form="form" :errors="errors" option-type="club" />
          </div>
        </div>
      </b-tab>
      <b-tab title="Placeholders" class="pt-6">
        <tab-placeholder :form="form" :errors="errors" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TabColor from "@/components/product/details/content/customize/TabColor.vue";
import TabCover from "@/components/product/details/content/customize/TabCover.vue";
import TabLoginImage from "@/components/product/details/content/customize/TabLoginImage.vue";
import TabPlaceholder from "@/components/product/details/content/customize/TabPlaceholder.vue";
import CoverOption from "./customize/CoverOption.vue";

export default {
  components: {
    TabPlaceholder,
    TabLoginImage,
    TabColor,
    TabCover,
    CoverOption
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { isMobile: window.innerWidth < 991 };
  },
  mounted() {
    document.addEventListener("resize", e => {
      this.isMobile = e.target.innerWidth < 991;
    });
  },
  computed: {
    tab1Title() {
      return this.isMobile ? "Fundo" : "Cor de fundo";
    },
    tab2Title() {
      return this.isMobile ? "Login" : "Imagens do Login";
    }
  }
};
</script>
